import React from 'react';
import colors from 'utils/colors';
import styled from 'styled-components';
import { HeadingTitle, HeaderFlexRow } from 'components/styled-components';

const VendorRequestHeader = props => (
  <HeaderFlexRow>
    <HeadingTitle>Create Assessment</HeadingTitle>
    <StepCounter>
      {' '}
      Step {props.currentStep} of {props.totalSteps}
    </StepCounter>
  </HeaderFlexRow>
);

const StepCounter = styled.div`
  color: ${colors.lightGray};
  padding-right: 0.75rem;
  font-size: 0.75rem;
`;

export default VendorRequestHeader;
